import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "27",
  fill: "none",
  viewBox: "0 0 25 27"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#000",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      d: "m13 9.37-4.646 2.778L13 14.926l4.646-2.778z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#000",
      "stroke-miterlimit": "10",
      d: "M17.646 12.148v5.556L13 20.482l-4.646-2.778v-5.556M13 14.926v5.556"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#000",
      "stroke-miterlimit": "10",
      d: "M7.141 7.426c1.617-1.111 3.637-1.76 5.859-1.76 5.555 0 10 4.167 10 9.167C23 19.926 18.454 24 13 24c-5.556 0-10-4.167-10-9.167 0-1.203.303-2.407.707-3.518"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#000",
      d: "m10.778 8.63.202-.649-3.536-.648.91-3.148L7.646 4l-1.11 3.889z"
    }, null, -1)
  ])))
}
export default { render: render }